import angular = require("angular");
import TPL = require("templates");

export class DishListDirective {

  template = TPL.contentDirectives.dishList;

  scope = {
    params: "=params"
  };
  link;

  constructor() {
    this.link = (scope, el, attrs) => {
        scope.vm = {
          submit: (form) => {
            if (form.$valid) {
              scope.params.items.push(scope.vm.dish);
              scope.vm.dish = "";
            }
          },
          removeItemAt: (i) => {
            scope.params.items.splice(i, 1);
          }

        }
      }
  }

  static factory() {
    var tmp = () => new DishListDirective();
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/dishList.ts
 **/